import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { TeamSiteComponentDetailsCall } from "../../../service/TeamSiteService";
import store from "../../../store/store";
import {Link} from "react-router-dom";
import delay from 'lodash/delay';
import get from 'lodash/get';
import Feedback from '../../../modules/feedback/Feedback';
import ChatComponent from '../../../modules/clicktochat/clicktochat';
import AdaChatLoader  from '../../../modules/clicktochat/Adachat';
import FeedbackRating from '../../../modules/feedback/FeedbackRating';
import { Helmet } from "react-helmet";
import { miawChatCheckLocale, safeHtmlParser } from '../../../utils';
const { REACT_APP_IMAGEURL } = window.weeksWebCloudConfig;

const FooterContainer = ({ 
    screenWidth, 
    pageContentDetails,
    customerId,
    accessToken,
    customerLocale,
    footerDetails,
    type,
    location,
    customerProfile }) => {
    
    useEffect(() => {
        if(footerDetails === null) getFooterData();  
    },[]);

    //Chat/feedback
    const [onlineButtonId, setOnlineButtonId] = useState();
    const [offlineButtonId, setOfflineButtonId] = useState();
    const [reactiveButtonId, setReactiveButtonId] = useState();
    const [footerFeedbackDisplay, setFooterFeedbackDisplay] = useState(false);
    const { MIAW_CHAT, AI_CHAT } = window.weeksWebCloudConfig;
    const setSalesforceParams = (onlineBtnId, offlineBtnId, reactiveBtnId) => {
      setOnlineButtonId(onlineBtnId);
      setOfflineButtonId(offlineBtnId);
      setReactiveButtonId(reactiveBtnId);
    };
    const closeFooterFeedback = (value) => {
      setFooterFeedbackDisplay(value);
    };
    const primaryId = get(customerProfile, 'subscriberId', '');
    const secondaryId = get(customerProfile, 'leadId', '');
    const brand = get(customerProfile, 'brandCode', '');
    const locale = get(customerProfile, 'locale', '');
    const memberTier=get(customerProfile, 'memberTierType', '');
    const AppDynamicvalues=" var currentLocale='"+locale +"'; var brandcode='"+brand+"'; var MemberTier='"+memberTier+"'; var SubscriberID='"+primaryId +"'; var MemberId='"+secondaryId +"';";
    const newChat = MIAW_CHAT && miawChatCheckLocale(locale);
    const isNewChatEnabled = AI_CHAT === true;
    React.useEffect(() => {
        // const chatHandler = ChatComponent({
        //     memberInfo: customerProfile,
        //     membershipDetails: customerProfile,
        //     setSalesforceParams,
        //     location,
        //     detailsAdded: true,
        // });
        // if (typeof chatHandler === 'function' && !newChat) {
        //     if (window.liveagent && window.chatDeploymentJSLoaded) {
        //         chatHandler(customerProfile, customerProfile, setSalesforceParams, location, true);
        //     } else {
        //         const script = document.createElement('script');
        //         script.type = 'text/javascript';
        //         script.async = true;
        //        // script.src = 'https://c.la2-c1-ia2.salesforceliveagent.com/content/g/js/50.0/deployment.js';
        //         // ********************DEV Testing changes***************
        //          script.src = 'https://c.la1-c1cs-ord.salesforceliveagent.com/content/g/js/49.0/deployment.js';
        //         // ********************DEV Testing changes end***************
        //         script.addEventListener('load', () => {
        //           window.chatDeploymentJSLoaded = true;
        //           delay(() => chatHandler(customerProfile, customerProfile, setSalesforceParams, location), 500);
        //         }, false);
        //         const head = document.getElementsByTagName('head')[0];
        //         head.appendChild(script);
        //     }
        // }
    }, [newChat]);
const getFooterData = () =>{

    pageContentDetails !== undefined && pageContentDetails.page_Content.Page_Row.find(value => {
            value.components.find(data => {
                
                if (data.name === "C84-Footer") {
                    let callParms={
                        customerId:customerId,
                        customerLocale:customerLocale,
                        TScompContentBody:data,
                        accessToken:accessToken,
                    }
                 
                    TeamSiteComponentDetailsCall(callParms).then(res => {
                      
                        if (res.status === 200) {
                           // console.log(footerStaticData.DynamicContent.document.Content);
                           //res = footerStaticData;
                           store.dispatch({type:"SET_FOOTER_DATA", payload:res.data.DynamicContent.document.Content})
                           //res = footerStaticData;
                           //store.dispatch({type:"SET_FOOTER_DATA", payload:footerStaticData.DynamicContent.document.Content})
                        }
                        else {
                            //console.log(res.data.fault.faultstring);
                        }
                    })
                }
            })
          

        });
    
}


if(footerDetails!== null){
    return (
        <>
           <Helmet><script type = 'text/javascript'>{AppDynamicvalues}</script> </Helmet>
            <footer id="post-login-footer">
                <div className="container">
                    <div className="row">
                        <div id="footer-logo" className="col-12 col-lg-2">
                            <Link className="footer-icon" to="/" data-testid="footer-rci-logo">
                                <img src={REACT_APP_IMAGEURL+footerDetails.FooterImageContainer.ImagePath} alt={footerDetails.FooterImageContainer.AltText} />
                            </Link>
                        </div>
                        <div id="links" className="col-lg-7 col-sm-12">
                            <div className="row">
                             <FooterNav {...footerDetails} screenWidth={screenWidth} />
                            </div>
                            
                        </div>
                        <div id="social" className="col-lg-3 col-12  text-lg-left">
                            <SocialMediaIcon {...footerDetails}  />
                            <div className="col-12 mt-4">
                               <FooterPhNumber numberDetails = {footerDetails} />   
                                <span className="footer-legal footnote text-center mt-3">{safeHtmlParser(footerDetails.CopyRightInfoContainer['CRIC-Description'])}</span>
                            </div>
                        </div>

                    </div>
                </div>
                {customerLocale!=="es_MX" &&
                <Feedback onlineButtonId={onlineButtonId} offlineButtonId={offlineButtonId} reactiveButtonId={reactiveButtonId} /> }
                {(footerFeedbackDisplay) && (
                  <FeedbackRating closeFeedBack={closeFooterFeedback} />
                )}
                {isNewChatEnabled && <AdaChatLoader />}
                {/* {newChat && <ChatComponent memberInfo={customerProfile} />} */}
                <ChatComponent memberInfo={customerProfile} />
            </footer>
        </>
    )
}
else return null
    
}

const mapStateToProps = state => ({
    screenWidth: state.CommonReducer.screenWidth,
    pageContentDetails: state.CommonReducer.pageContent,
    customerId: state.CommonReducer.customerId,
    customerLocale: state.CommonReducer.locale,
    accessToken: state.CommonReducer.accessToken,
    footerDetails : state.CommonReducer.footerData,
    customerProfile:state.CommonReducer.customerProfile
})

export default connect(mapStateToProps)(FooterContainer);
let prevLinkIndex = 0;
const FooterNav = ({ RCIFooter, screenWidth }) => {
    //console.log(RCIFooter);
    
    const footerMenu = (currlinkindex, event) => {
        //debugger;
        //console.log(currlinkindex);
        const nextElm = event.currentTarget.parentNode;
        const CurrElm = event.currentTarget.parentNode;
        let linkElemList = document.getElementsByClassName("footer-list-group");
       
        //debugger;
        if (prevLinkIndex !== currlinkindex) {
            for (let footerListElem of linkElemList) {
                footerListElem.classList.remove("open");
            }
            linkElemList[currlinkindex].classList.add("open");
            prevLinkIndex = currlinkindex;
        }
        else if ((prevLinkIndex === currlinkindex )) {
             if (!CurrElm.classList.contains("open")) CurrElm.classList.add("open");
            else CurrElm.classList.remove("open");
            prevLinkIndex = currlinkindex;
        }
     /*    else if (nextElm.classList.contains("open")) {
            nextElm.classList.toggle("open");
        }
        else if (!nextElm.classList.contains("open")) {
            nextElm.classList.add("open");
        } */

    }
    return (

        RCIFooter.LinksContainer.map((footermainlinkData, index) => {
            return (

                <div className="footer-list-group" 
                data-testid={footermainlinkData.TitleText}
                key={index}
                >

                    <a href="#!" key={index} className="footer-title" 
                    aria-label={footermainlinkData.TitleText} 
                    onClick={(event) => footerMenu(index, event)}>{footermainlinkData.TitleText}</a>

                    <ul className="footer-listing" >
                        {footermainlinkData.FooterLinks.map((footersubMenuData, indexNumber) => {
                            return (
                                <li key={indexNumber} data-testid={footersubMenuData.HoverText}>
                                    <a href={footersubMenuData.Url} 
                                    className="text-black"
                                    key={indexNumber} 
                                    target ={footersubMenuData.ExternalIndicator === 2 ? "_blank" : "_self"}
                                    aria-label={footersubMenuData.HoverText}>{safeHtmlParser(footersubMenuData.DisplayText)}</a>
                                </li>
                            )
                        })}
                    </ul>
                </div>



            )
        })
    )

}

const SocialMediaIcon = ({ SocialButtonsSection}) => {
    return (
        <>

            <div className="pt-lg-0 pt-6"><p className="footer-headline text-center m-0">{SocialButtonsSection.SocialMediaTitle}</p></div>
          
            <div className="row pt-4 justify-content-center m-0">
                {SocialButtonsSection.SocialButtonsIcons.map((iconDeatils, index) => {
                    return (
                        <div className="col-2" key={index}>
                            <a href={iconDeatils["SBI-Link"]} 
                            data-testid={iconDeatils["SBI-IconImageAltTxt"]}
                            aria-label={iconDeatils["SBI-Icon"]}
                            target ={iconDeatils["SBI-ExternalIndicator"] === 2 ? "_blank" : "_self"}
                            className="fab pr-3" key={index}>
                                <img src={iconDeatils["SBI-IconImage"]} className="svg-fill-black mx-auto" alt={iconDeatils["SBI-Icon"]} />
                            </a>
                        </div>
                    )
                })}
            </div>
          
            

        </>
    )
}

const FooterPhNumber = ({numberDetails})=>{
    //debugger;
    //console.log(numberDetails);
    const numberList = (phMapData) =>{
        return(
            <a className="ph-number-link" href={`tel:+${phMapData.DisplayNumber}`}>{safeHtmlParser(phMapData.DisplayNumber)}</a>      
              
        )

    }

    return (
        <>
        {numberDetails.ContactInfo.length === undefined ?
            <p className="footer-legal footnote text-center mb-2"><span>{numberDetails.ContactInfo.DisplayText}</span><a className="ml-2 ph-number-link" href={numberDetails.ContactInfo.HiddenDisplayNumber}>{numberDetails.ContactInfo.DisplayNumber}</a></p>
            :
            numberDetails.ContactInfo.map((conatctMapData)=>{
               return(
                   <>
             {/*   <div className="footer-legal row footnote mb-2">
                    <div className="col-lg-5 text-lg-right text-sm-center px-0">{conatctMapData.DisplayText}</div>
                    <div className="col-lg-7">{numberList(conatctMapData)}</div>
               </div> */}
               <div className="footer-legal row footnote mb-2">
                    <div className="col-12 text-center px-0"><b>{conatctMapData.DisplayText} </b> <span className='font-weight-light'>{numberList(conatctMapData)}</span></div>
                   {/*  <div className="col-lg-7"></div> */}
               </div>
               
               </>
               
               ) 
            })    
            }
     </>       
    )


}
